import * as Grid from '@progress/kendo-react-grid'
import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import * as IsActive from '../../components/is_active'
import { Link } from '../../components/link'
import * as RootConstants from '../../constants'
import './styles.css'

type OnEdit<T> = (x: T, y: string) => any

export class ActiveAndEditCell<T> extends Grid.GridCell {
  private eventName: string = ''
  private disabled: boolean = false
  private linkUrl: string
  private onEdit: OnEdit<T>
  private prop: string
  private showClone: boolean = false

  constructor(
    props: Grid.GridCellProps,
    eventName: string,
    disabled: boolean,
    linkUrl?: string,
    onEdit?: OnEdit<T>,
    prop?: string,
    showClone?: boolean,
  ) {
    super(props)
    this.eventName = eventName
    this.disabled = disabled
    this.linkUrl = linkUrl
    this.onEdit = onEdit
    this.prop = prop
    this.showClone = showClone
  }
  public render() {
    return <td>
            <Col className="edit-active">
              <Row>
                <span className="active-toggle small-slider">
                  <IsActive.ToggleButton event={this.eventName}
                                        id={this.props.dataItem.id}
                                        is_active={this.props.dataItem[this.props.field]}
                                        props={this.props}
                                        disabled={this.disabled}/>
                </span>
              </Row>
              <Row>
                {!!this.linkUrl === false
                ?
                <span>
                  <div className="button-container">
                    <div>
                      <Button className="secondary-button small-btn edit"
                        onClick={(() =>
                          this.props.dataItem.dispatch(this.onEdit(this.props.dataItem, RootConstants.EDIT)))}
                        id="Edit">
                          {RootConstants.EDIT}
                      </Button>
                    </div>
                    {this.showClone === true &&
                    <div className="clone">
                      <Button className="secondary-button small-btn edit"
                        onClick={(() =>
                          this.props.dataItem.dispatch(this.onEdit(this.props.dataItem, RootConstants.CLONE)))}
                        id="Edit">
                          {RootConstants.CLONE}
                      </Button>
                    </div>
                    }
                  </div>
                </span>
                :
                <Link
                  className="secondary-button small-btn edit"
                  href={`${this.linkUrl}/${this.prop ? this.prop : this.props.dataItem.id}`}
                  id="Edit">
                    {RootConstants.EDIT}
                </Link>
                }
              </Row>
            </Col>
        </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/active_and_edit_cell.tsx